import InterestedLeadTemplate from "../../../../components/templates/LeadTemplates/InterestedrLeadTemplate/InterestedLeadTemplate";

const InterestedLeads = () => {
  return <InterestedLeadTemplate />;
};

export default InterestedLeads;
